import React, { Component } from "react";
import PropTypes from "prop-types";

import {
  Input,
  Checkbox,
  Select,
  Typography,
  Upload,
  message,
  Row,
  Button,
  Tag,
  InputNumber,
  DatePicker,
  TimePicker,
  Tooltip,
  Spin,
} from "antd";
import Zip from "jszip";
import {
  objectbyString,
  objectAssignerByString,
  syntaxHighlightJSON,
  schema_to_field,
} from "../util";
import moment from "moment";
import NetworkSelect from "./network_select";
import ScheduleChanger from "./schedule_changer";
import { CirclePicker } from "react-color";
import {
  InboxOutlined,
  DeleteOutlineOutlined,
  HelpOutlineOutlined,
  DragIndicator,
} from "@material-ui/icons";
import lodash from "lodash";
import { TagSelector } from "./tag_selector";
import BasicConfigForm from "./basic_config_form";
import ComplexConfigForm from "./complex_config_form";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { CustomSwitch } from "../../components/basic_items";
import { JsonEditor as Editor } from "jsoneditor-react";
import "jsoneditor-react/es/editor.min.css";

import ace from "brace";
import "brace/mode/json";
import "brace/theme/tomorrow_night_blue";
import { COLORS } from "../../pages/theme";

const { TextArea } = Input;
const Dragger = Upload.Dragger;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: 2,
  margin: `0 0 ${0}px 0`,

  // change background colour if dragging
  background: isDragging ? "white" : "white",

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "lightblue" : null,
  padding: 2,
  // width: 250
});

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.initialData ? props.initialData : {},
      schema: this.props.fields || [],
      additional_forms: {},
      toggle_json_config: {},
    };
    this.data_buffers = {};
    this.compression_progress = {};

    this._change = this._change.bind(this);
    this._getFieldByType = this._getFieldByType.bind(this);
    this._getInputFields = this._getInputFields.bind(this);
    this._addBase64Buffer = this._addBase64Buffer.bind(this);
    console.log(props, "this the props of table");
  }
  reconcileSchemaBasedOnForm = (_schema = [], _data = {}) => {
    console.log("reconciling...");
    let old_schema = JSON.parse(JSON.stringify(_schema));

    _schema.map(async (item, schemaIndex) => {
      if (item.multiple) {
        console.log("found multiple for", item);
        // field has multiple value so lets check for data now
        console.log("dataa is", _data[item.index]);
        if (Array.isArray(_data[item.index])) {
          console.log("data is array");
          old_schema = this.reconcileChildrenForMultiple(
            `[${schemaIndex}]`,
            _data[item.index].length == 0 ? 0 : _data[item.index].length - 1,
            old_schema
          );
          console.log("new schema received", old_schema);
        }
      }
    });
    console.log("new schema is", old_schema);
    this.setState({
      schema: old_schema,
    });
  };
  _getFieldByType(item, d_key) {
    // console.log("FILED MAKER",item,d_key)
    let form_value = null;

    form_value = objectbyString(this.state.data, d_key);

    // Assigning default values if provided and initial value null
    if (form_value == null && item.default != null) {
      this._change(item.index, item.default, d_key);
    }

    if (item.type === "text") {
      return (
        <Input
          style={{
            width: item.width || "100%",
          }}
          name={item.index}
          placeholder={item.name}
          value={form_value == null ? "" : form_value}
          onChange={(e) => this._change(item.index, e.target.value, d_key)}
        />
      );
    } else if (item.type == "schedule") {
      return (
        <ScheduleChanger
          schedule={form_value || {}}
          onChange={(schedule) => {
            this._change(item.index, schedule, d_key);
          }}
        />
      );
    } else if (item.type === "form") {
      // console.log("FORM CREATED",this.props.initialData,this.props.parentData)
      return (
        <div
          style={{
            border: COLORS.border,
            display: "flex",
            flex: 1,
            flexDirection: "column",
          }}
        >
          <Form
            forCreate={true}
            parentData={{
              ...this.props.parentData,
              ...this.state.data,
            }}
            isChild={true}
            isHorizontal={item.isHorizontal}
            initialData={form_value || {}}
            submitted={this.props.submitted}
            form_style={{ display: "flex", flex: 1, flexDirection: "column" }}
            onChange={(received_value) => {
              this._change(item.index, received_value, d_key);
            }}
            fields={item.schema}
            errorMessage={{}}
            validationErrors={
              objectbyString(this.props.validationErrors || {}, d_key) || {}
            }
          />
        </div>
      );
    } else if (item.type === "networkselect") {
      console.log(
        "SENDING FOR NETWORK",
        item.name,
        this.props.parentData,
        this.props.initialData,
        this.state.data
      );
      return (
        <NetworkSelect
          key={`${item.index}--`}
          value={form_value}
          item={item}
          url={item.url}
          send_params={item.send_params}
          send_params_keys={item.send_params_keys}
          // ext_params={{
          //   ...this.props.parentData,
          //   ...this.state.data,

          // }}
          ext_params={Object.assign(
            {},
            this.props.parentData,
            this.state.initialData,
            this.state.data
          )}
          onChange={(received_value) => {
            this._change(item.index, received_value, d_key);
          }}
        />
      );
    } else if (item.type == "number") {
      return (
        <InputNumber
          style={{
            width: item.width || "100%",
          }}
          name={item.index}
          placeholder={item.name}
          value={form_value == null ? "" : form_value}
          onChange={(value) => this._change(item.index, value, d_key)}
        />
      );
    } else if (item.type == "textarea") {
      return (
        <TextArea
          name={item.index}
          placeholder={item.name}
          rows={item.maxline}
          value={form_value == null ? "" : form_value}
          onChange={(e) => this._change(item.index, e.target.value, d_key)}
        />
      );
    } else if (item.type == "json") {
      let formated_json = "";
      // try{
      //   if(form_value&& typeof form_value==='string'){
      //     // console.log("String")
      //     let main_value=form_value.substring(0,form_value.length);
      //     // console.log("MAIN",main_value)
      //     // console.log(JSON.parse(main_value));
      //     // formated_json=(JSON.stringify(JSON.parse(main_value),null,`\t`));
      //     console.log("TRYING",formated_json);
      //   }else if(form_value&&typeof form_value==='object'){
      //     console.log("ALREADY OBJECT")
      //     // formated_json=(JSON.stringify(form_value,null,4))
      //   }

      // }catch(e){
      //   formated_json="Not a valid JSON"
      // }
      // if(typeof form_value==='object'){
      //   form_value=JSON.stringify(form_value,null,4)
      // }

      // console.log(JSON.stringify({"s":4}))

      return (
        <div className="json-editor-wrapper large">
          <Editor
            mode={Editor.modes.code}
            value={form_value || {}}
            onChange={(value) => {
              console.log("change value is", value);

              this._change(item.index, value, item.index);
            }}
            className="small-json-editor"
            search={false}
            navigationBar={false}
            statusBar={false}
            ace={ace}
            theme="ace/theme/github"
          />
        </div>
      );
      return (
        <Row type="flex" style={{ flexWrap: "nowrap" }}>
          <TextArea
            autosize={{
              maxRows: 14,
              minRows: 4,
            }}
            style={{ minWidth: 300 }}
            name={item.index}
            placeholder={item.name}
            rows={item.maxline || 4}
            value={form_value == null ? "" : form_value}
            onChange={(e) => this._change(item.index, e.target.value, d_key)}
            onBlur={(e) => {
              let d = e.target.value;
              try {
                d = JSON.parse(d);
              } catch (e) {}
              this._change(item.index, d, d_key);
            }}
          />
          <div>
            <pre style={{}}>
              <code>{formated_json}</code>
            </pre>
          </div>
        </Row>
      );
    } else if (item.type == "password") {
      return (
        <Input.Password
          name={item.index}
          value={form_value == null ? "" : form_value}
          type="password"
          placeholder={item.name}
          visibilityToggle={item.toggle}
          onChange={(e) => this._change(item.index, e.target.value, d_key)}
        />
      );
    } else if (item.type == "bool") {
      if (form_value == null && item.default == null) {
        this._change(item.index, false, d_key);
      }
      return (
        <Checkbox
          name={item.index}
          checked={Boolean(form_value)}
          onChange={(e, v) => this._change(item.index, e.target.checked, d_key)}
        />
      );
    } else if (item.type == "date") {
      let dateFormat = item.format || "YYYY-MM-DD";
      let disabledTo = item.disabledTo;
      let disabledDate = (_date) => {
        if (disabledTo && moment(disabledTo, "YYYY-MM-DD").isValid()) {
          return _date <= moment(disabledTo, "YYYY-MM-DD");
        } else {
          return false;
        }
      };
      let val = moment(form_value, dateFormat).isValid()
        ? moment(form_value, dateFormat)
        : null;
      return (
        <DatePicker
          name={item.index}
          format={dateFormat}
          disabledDate={disabledDate}
          showToday
          value={val}
          onChange={(date, dateString) => {
            this._change(item.index, dateString, d_key);
          }}
        />
      );
    } else if (item.type == "datetime") {
      let dateFormat = item.format || "YYYY-MM-DD HH:mm";
      let disabledTo = item.disabledTo;
      let disabledDate = (_date) => {
        if (disabledTo && moment(disabledTo, "YYYY-MM-DD HH:mm").isValid()) {
          return _date <= moment(disabledTo, "YYYY-MM-DD HH:mm");
        } else {
          return false;
        }
      };
      let val = moment(form_value, dateFormat).isValid()
        ? moment(form_value, dateFormat)
        : null;
      return (
        <DatePicker
          showTime
          name={item.index}
          format={dateFormat}
          disabledDate={disabledDate}
          showToday
          value={val}
          onChange={(date, dateString) => {
            this._change(item.index, dateString, d_key);
          }}
        />
      );
    } else if (item.type == "time") {
      let timeFormat = item.format || "h:mma";
      let val = moment(form_value, timeFormat).isValid()
        ? moment(form_value, timeFormat)
        : null;
      return (
        <TimePicker
          style={{
            width: item.width || "100%",
          }}
          name={item.index}
          use12Hours
          format={timeFormat}
          value={val}
          onChange={(time, timeString) => {
            this._change(item.index, timeString, d_key);
          }}
        />
      );
    } else if (item.type === "tagselect") {
      return (
        <TagSelector
          value={form_value}
          options={item.options}
          onChange={(value) => {
            this._change(item.index, value, d_key);
          }}
        />
      );
    } else if (item.type === "basicconfig") {
      return (
        <BasicConfigForm
          count={item.count}
          value={form_value}
          onChange={(value) => {
            console.log("on channge ", value);
            this._change(item.index, value, d_key);
          }}
        />
      );
    } else if (item.type === "complexconfig") {
      return (
        <ComplexConfigForm
          count={item.count}
          toggle_ui_json={item.toggle_ui_json}
          extra_fields={item.extra_fields}
          value={form_value}
          onChange={(value) => {
            console.log("on channge ", value);
            this._change(item.index, value, d_key);
          }}
        />
      );
    } else if (item.type === "activityconfig") {
      return (
        <ComplexConfigForm
          count={item.count}
          activity_table_upload_file={true}
          toggle_ui_json={item.toggle_ui_json}
          extra_fields={item.extra_fields}
          value={form_value}
          onChange={(value) => {
            console.log("on channge ", value);
            this._change(item.index, value, d_key);
          }}
        />
      );
    } else if (item.type == "select") {
      let filter_option = {};
      if (item.filterable) {
        filter_option = {
          filterOption: (input, option) => {
            console.log("OPTION IS", option);
            if (typeof option.props.children === "string") {
              return (
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              );
            } else if (
              option.props.children &&
              option.props.children.props &&
              option.props.children.props.name
            ) {
              return (
                option.props.children.props.name
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              );
            }
          },
        };
      }
      return (
        <Select
          style={{
            width: item.width || "100%",
          }}
          value={form_value}
          showSearch={item.filterable}
          {...filter_option}
          loading={item.isLoading}
          mode={item.mode || "default"}
          allowClear
          placeholder={item.name}
          onChange={(value) => {
            // console.log(value)
            this._change(item.index, value || null, d_key);
            typeof item.onChange == "function" &&
              item.onChange(item.index, value, d_key);
          }}
        >
          {Array.isArray(item.options) &&
            item.options.map((option) => {
              return (
                <Select.Option key={option.value} value={option.value}>
                  {option.render ? option.render(option.text) : option.text}
                </Select.Option>
              );
            })}
        </Select>
      );
    } else if (item.type === "color_picker") {
      return (
        <div
          style={{ display: "flex", flexDirection: "column", paddingTop: 8 }}
        >
          {/* <div style={{marginBottom:8,paddingBottom:16,marginTop:6,display:'flex',flexDirection:'row',borderBottom:'1px solid #ddd'}}>Picked Color: &nbsp;&nbsp;&nbsp;&nbsp;<div style={{width:28,height:28,borderRadius:14,backgroundColor:form_value
        }}>{form_value==null&&"N/A"}</div></div> */}
          <CirclePicker
            color={form_value}
            onChange={(color) => {
              console.log("color ", color);
              this._change(item.index, color.hex, d_key);
            }}
          />
          {/* <input type="color"
          id="head"
          name="head"
          onChange={(e) => this._change(item.index, e.target.value, d_key)}
          value={form_value} /> */}
        </div>
      );
    } else if (item.type == "base64_file") {
      let fileName = objectbyString(this.state.data, `${d_key}__fileName`);
      console.log("form value fle base4", form_value);

      return (
        <Dragger
          className="customDragger"
          name="file"
          multiple={false}
          accept={item.accept}
          customRequest={(option) => {
            return true;
          }}
          showUploadList={false}
          onChange={(info) => {
            console.log("info file", info);

            let reader = new FileReader();
            var _base64;
            this._change(
              item.index,
              info.file.originFileObj.name,
              `${d_key}__fileName`
            );
            reader.onload = (e) => {
              _base64 = e.target.result;
              this._change(item.index, _base64, d_key);
            };
            reader.readAsDataURL(info.file.originFileObj);
          }}
        >
          <p className="ant-upload-drag-icon">
            {this.compression_progress[item.index] ? (
              <Spin />
            ) : (
              <InboxOutlined />
            )}
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">Support for a single file upload.</p>
          {form_value && (
            <Tag
              style={{ zIndex: 100 }}
              closable
              onClose={(e) => {
                e.stopPropagation();
                this._change(item.index, null, `${d_key}__fileName`);
                setTimeout(() => {
                  this._change(item.index, null, d_key);
                }, 100);
              }}
            >
              {" "}
              {fileName}
            </Tag>
          )}
        </Dragger>
        // <Input fluid name={item.index}
        //   type='file'
        //   onChange={(e) => {this._change(item.index, e.target.files[0]);}}
        //   onClick={(e) => e.target.value = null}
        // />
      );
    } else if (item.type == "file") {
      return (
        <Dragger
          className="customDragger"
          name="file"
          multiple={false}
          accept={item.accept}
          customRequest={(option) => {
            return true;
          }}
          showUploadList={false}
          onChange={(info) => {
            console.log("info file", info);
            if (item.compress) {
              this.compression_progress = {
                ...this.compression_progress,
                [item.index]: true,
              };
              this.setState({
                ...this.state,
              });
              let ctx = this;
              let z = new Zip();
              let fi = info.file.originFileObj;
              z.file(fi.name, fi);
              z.generateAsync({ type: "blob", compression: "DEFLATE" })
                .then(function (content) {
                  // console.log(content)
                  let f = new File([content], `${fi.name}.zip`, {
                    type: "application/zip",
                  });
                  content.name = "some.zip";
                  delete ctx.compression_progress[item.index];
                  ctx._change(item.index, f, d_key);
                  // console.log("Changingggg")
                  // ctx.setState({
                  //     compress_progress:{...ctx.state.compress_progress,[key]:false}
                  // })
                  // ctx.sendFile(f,key);
                })
                .catch((error) => {
                  // console.log("ERROR OCCURED IN COMPRESSION", error);
                  message.error("Error reading file. Please try again");
                  // ctx.setState({
                  //     compress_progress:{...ctx.state.compress_progress,[key]:false}
                  // })
                });
            }

            this._change(item.index, info.file.originFileObj, d_key);
          }}
        >
          <p className="ant-upload-drag-icon">
            {this.compression_progress[item.index] ? (
              <Spin />
            ) : (
              <InboxOutlined />
            )}
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">Support for a single file upload.</p>
          {form_value && (
            <Tag
              style={{ zIndex: 100 }}
              closable
              onClose={(e) => {
                e.stopPropagation();
                this._change(item.index, null);
              }}
            >
              {" "}
              {form_value.name}
            </Tag>
          )}
        </Dragger>
        // <Input fluid name={item.index}
        //   type='file'
        //   onChange={(e) => {this._change(item.index, e.target.files[0]);}}
        //   onClick={(e) => e.target.value = null}
        // />
      );
    } else if (item.type == "file") {
      return (
        <Dragger
          className="customDragger"
          name="file"
          multiple={false}
          accept={item.accept}
          customRequest={(option) => {
            return true;
          }}
          showUploadList={false}
          onChange={(info) => {
            console.log("info file", info);
            if (item.compress) {
              this.compression_progress = {
                ...this.compression_progress,
                [item.index]: true,
              };
              this.setState({
                ...this.state,
              });
              let ctx = this;
              let z = new Zip();
              let fi = info.file.originFileObj;
              z.file(fi.name, fi);
              z.generateAsync({ type: "blob", compression: "DEFLATE" })
                .then(function (content) {
                  // console.log(content)
                  let f = new File([content], `${fi.name}.zip`, {
                    type: "application/zip",
                  });
                  content.name = "some.zip";
                  delete ctx.compression_progress[item.index];
                  ctx._change(item.index, f, d_key);
                  // console.log("Changingggg")
                  // ctx.setState({
                  //     compress_progress:{...ctx.state.compress_progress,[key]:false}
                  // })
                  // ctx.sendFile(f,key);
                })
                .catch((error) => {
                  // console.log("ERROR OCCURED IN COMPRESSION", error);
                  message.error("Error reading file. Please try again");
                  // ctx.setState({
                  //     compress_progress:{...ctx.state.compress_progress,[key]:false}
                  // })
                });
            }

            this._change(item.index, info.file.originFileObj, d_key);
          }}
        >
          <p className="ant-upload-drag-icon">
            {this.compression_progress[item.index] ? (
              <Spin />
            ) : (
              <InboxOutlined />
            )}
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">Support for a single file upload.</p>
          {form_value && (
            <Tag
              style={{ zIndex: 100 }}
              closable
              onClose={(e) => {
                e.stopPropagation();
                this._change(item.index, null);
              }}
            >
              {" "}
              {form_value.name}
            </Tag>
          )}
        </Dragger>
        // <Input fluid name={item.index}
        //   type='file'
        //   onChange={(e) => {this._change(item.index, e.target.files[0]);}}
        //   onClick={(e) => e.target.value = null}
        // />
      );
    } else if (item.type == "audio") {
      return (
        <div>
          <Input
            fluid
            name={item.index}
            label={item.name}
            type="file"
            onChange={(e) => {
              this._addBase64Buffer(item.index, e.target.files[0]);
              this._change(item.index, e.target.files[0]);
            }}
            onClick={(e) => (e.target.value = null)}
          />
          {this.state.__base64_buffer__ &&
            this.state.__base64_buffer__[item.index] && (
              <audio controls src={this.data_buffers[item.index]} />
            )}
        </div>
      );
    } else if (item.type == "video") {
      return (
        <div>
          <Input
            fluid
            name={item.index}
            label={item.name}
            type="file"
            onChange={(e) => {
              this._addBase64Buffer(item.index, e.target.files[0]);
              this._change(item.index, e.target.files[0]);
            }}
            onClick={(e) => (e.target.value = null)}
          />
          {this.state.__base64_buffer__ &&
            this.state.__base64_buffer__[item.index] && (
              <video
                width={120}
                height={120}
                controls
                src={this.data_buffers[item.index]}
              />
            )}
        </div>
      );
    } else return <div>Input type not defined for {item.type}</div>;
  }

  addChildren = (s_key) => {
    let schema = JSON.parse(JSON.stringify(this.state.schema));
    // console.log(schema[parentIndex],parentIndex)
    let data_to_change = objectbyString(schema, s_key);
    // console.log("PREV DATA TO CHANGe", data_to_change)

    if (Array.isArray(data_to_change) && data_to_change.length > 0) {
      data_to_change.push(data_to_change[0]);
      // console.log("is array")
      objectAssignerByString(schema, s_key, data_to_change);
    }

    // console.log("DATA TO CHANGE", schema, data_to_change, s_key)
    // if(Array.isArray(schema[parentIndex].children)){

    //   schema[parentIndex].children.push(schema[parentIndex].children[0]);
    // }
    this.setState({
      schema: schema,
    });
  };

  reconcileChildrenForMultiple = (s_key, items_to_add = 1, old_schema) => {
    console.log("async adding children", items_to_add, s_key, old_schema);
    let _schema = JSON.parse(JSON.stringify(old_schema));
    // console.log(schema[parentIndex],parentIndex)
    let data_to_change = objectbyString(_schema, s_key);
    // console.log("PREV DATA TO CHANGe", data_to_change);
    if (data_to_change.count != null) {
      data_to_change.count += items_to_add;
      objectAssignerByString(_schema, s_key, data_to_change);
    }
    console.log("async new schema", _schema);
    return _schema;
    // this.setState({
    //   schema: _schema
    // }, () => {
    //   console.log("async updated schema", this.state.schema, _schema);
    //   resolve(`Success For ${s_key},${items_to_add}`);
    // })
  };

  reconcileChildrenForMultiplea = async (s_key, items_to_add = 1) => {
    console.log("async adding children", items_to_add, s_key);
    let _schema = JSON.parse(JSON.stringify(this.state.schema));
    // console.log(schema[parentIndex],parentIndex)
    let data_to_change = objectbyString(_schema, s_key);
    // console.log("PREV DATA TO CHANGe", data_to_change);
    if (data_to_change.count != null) {
      data_to_change.count += items_to_add;
      objectAssignerByString(_schema, s_key, data_to_change);
    }
    console.log("async new schema", _schema);

    this.setState(
      {
        schema: _schema,
      },
      () => {
        console.log("async updated schema", this.state.schema, _schema);
      }
    );
  };

  addChildrenField = (s_key, items_to_add = 1) => {
    console.log("adding children", items_to_add, s_key);
    let _schema = JSON.parse(JSON.stringify(this.state.schema));
    // console.log(schema[parentIndex],parentIndex)
    let data_to_change = objectbyString(_schema, s_key);
    // console.log("PREV DATA TO CHANGe", data_to_change);
    if (data_to_change.count != null) {
      data_to_change.count += items_to_add;
      objectAssignerByString(_schema, s_key, data_to_change);
    }
    console.log("new schema", _schema);

    this.setState(
      {
        schema: _schema,
      },
      () => {
        console.log("updated schema", this.state.schema, _schema);
      }
    );
  };

  removeChildren = (s_key, d_key, child_index) => {
    // console.log("REmoving", d_key, s_key, child_index);

    let schema = JSON.parse(JSON.stringify(this.state.schema));
    let data = JSON.parse(JSON.stringify(this.state.data));

    let schemaarray_to_remove = objectbyString(schema, s_key);
    let dataarray_to_remove = objectbyString(data, d_key);
    // console.log("GOT", schemaarray_to_remove, dataarray_to_remove)

    if (
      Array.isArray(schemaarray_to_remove) &&
      schemaarray_to_remove.length > 0
    ) {
      // console.log("Schema  found")
      schemaarray_to_remove.splice(child_index, 1);
    }
    if (Array.isArray(dataarray_to_remove) && dataarray_to_remove.length > 0) {
      // console.log("Data  found")

      dataarray_to_remove.splice(child_index, 1);
    }
    objectAssignerByString(schema, s_key, schemaarray_to_remove);
    objectAssignerByString(data, d_key, dataarray_to_remove);
    // console.log("AFTER DELETE", data, schema)
    // if(Array.isArray(schema[parentIndex].children)){
    //   schema[parentIndex].children.splice(childIndex,1);
    // }
    // if(Array.isArray(data[parentKey])&&data[parentKey][childIndex]){

    //   console.log("Removing data",data[parentKey][childIndex])
    //   data[parentKey].splice(childIndex,1);
    // }

    this.setState(
      {
        data: data,
        schema: schema,
      },
      () => {
        typeof this.props.onChange === "function" && this.props.onChange(data);
      }
    );
  };
  removeChildrenField = (s_key, d_key, child_index) => {
    console.log(
      "Removing child val",
      d_key,
      s_key,
      child_index,
      this.state.schema,
      this.state.data
    );

    let schema = JSON.parse(JSON.stringify(this.state.schema));
    let data = JSON.parse(JSON.stringify(this.state.data || {}));

    let schema_to_change = objectbyString(schema, s_key);
    let dataarray_to_remove = objectbyString(data, d_key);

    console.log("GOT", schema_to_change, dataarray_to_remove);

    if (schema_to_change.count != null && schema_to_change.count > 0) {
      // console.log("Schema  found")
      schema_to_change.count -= 1;
    }
    if (Array.isArray(dataarray_to_remove) && dataarray_to_remove.length > 0) {
      // console.log("Data  found")
      dataarray_to_remove.splice(child_index, 1);
    }
    // objectAssignerByString(schema,s_key,schemaarray_to_remove);
    objectAssignerByString(data, d_key, dataarray_to_remove);
    // console.log("AFTER DELETE", data, schema)

    this.setState(
      {
        data: data,
        schema: schema,
      },
      () => {
        typeof this.props.onChange === "function" && this.props.onChange(data);
      }
    );
  };

  reorderArrayData = (list, startIndex, endIndex) => {
    console.log(list, startIndex, endIndex);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  onDragEnd(result, d_key) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    console.log("on drag end", result, d_key);

    let _data = JSON.parse(JSON.stringify(this.state.data));

    let list_data = objectbyString(_data, d_key);

    if (Array.isArray(list_data)) {
      const _newArrayData = this.reorderArrayData(
        list_data,
        result.source.index,
        result.destination.index
      );

      this._change(null, _newArrayData, d_key);
    }

    // this.setState({
    //   items
    // });
  }

  _getMultipleFieldByType = (data, s_key, d_key) => {
    let min_children = data.min == null ? 1 : data.min;
    let max_children = data.max || Infinity;
    let count = data.count == null ? 1 : data.count;
    let multiple = data.multiple || false;
    // console.log("get multiple")

    if (data.isDraggable) {
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <DragDropContext
            onDragEnd={(result) => {
              this.onDragEnd(result, d_key);
            }}
          >
            <Droppable droppableId={`${d_key}`}>
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {Array(count)
                    .fill(1)
                    .map((i, childIndex) => {
                      return (
                        <Draggable
                          key={`${childIndex}`}
                          draggableId={`${childIndex}`}
                          index={childIndex}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              style={{
                                ...getItemStyle(
                                  snapshot.isDragging,
                                  provided.draggableProps.style
                                ),
                                ...data.childrenStyle,
                              }}
                            >
                              <Row
                                type={"flex"}
                                justify="space-around"
                                align="middle"
                                style={{
                                  flexWrap: "nowrap",
                                  marginTop: 4,
                                  marginBottom: 4,
                                }}
                              >
                                <div
                                  {...provided.dragHandleProps}
                                  style={{
                                    width: 30,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignSelf: "stretch",
                                    alignItems: "center",
                                  }}
                                >
                                  <DragIndicator className="basic-icon" />
                                </div>
                                {this._getFieldByType(
                                  data,
                                  `${d_key}[${childIndex}]`
                                )}
                                <center>
                                  <Button
                                    disabled={count <= min_children}
                                    onClick={() =>
                                      this.removeChildrenField(
                                        `${s_key}`,
                                        `${d_key}`,
                                        childIndex
                                      )
                                    }
                                    type="link"
                                    style={{
                                      color: "red",
                                      display: "flex",
                                      alignItems: "center",
                                      opacity: count <= min_children ? 0 : 1,
                                    }}
                                  >
                                    <DeleteOutlineOutlined type="delete" />
                                    {/* {display_type==='vertical'?"Delete":""} */}
                                  </Button>
                                </center>
                              </Row>
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          {multiple && count < max_children && (
            <Button
              style={{ marginTop: 8 }}
              onClick={() => this.addChildrenField(s_key)}
            >
              {data.add_more || "Add More"}
            </Button>
          )}
        </div>
      );
    }

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        {Array(count)
          .fill("0")
          .map((i, childIndex) => {
            // console.log("render")
            return (
              <Row
                type={"flex"}
                justify="space-around"
                align="middle"
                style={{ flexWrap: "nowrap", marginTop: 4, marginBottom: 4 }}
              >
                {this._getFieldByType(data, `${d_key}[${childIndex}]`)}
                <center>
                  <Button
                    disabled={count <= min_children}
                    onClick={() =>
                      this.removeChildrenField(
                        `${s_key}`,
                        `${d_key}`,
                        childIndex
                      )
                    }
                    type="link"
                    style={{
                      color: "red",
                      display: "flex",
                      alignItems: "center",
                      opacity: count <= min_children ? 0 : 1,
                    }}
                  >
                    <DeleteOutlineOutlined type="delete" />
                    {/* {display_type==='vertical'?"Delete":""} */}
                  </Button>
                </center>
              </Row>
            );
          })}

        {/* <br></br> */}
        {multiple && count < max_children && (
          <Button
            style={{ marginTop: 8 }}
            block
            onClick={() => this.addChildrenField(s_key)}
          >
            {data.add_more || "Add More"}
          </Button>
        )}
      </div>
    );
  };

  _getFieldsForChildren(data, parentIndex, children_error = {}, s_key, d_key) {
    let childrens = data.children || [];
    let multiple = data.multiple;
    let parentKey = data.index;
    let min_children = data.min == null ? 1 : data.min;
    console.log("checking data", data, data.min, min_children);
    let max_children = data.max || Infinity;
    let display_type = data.positioning || "horizontal";

    // console.log("CILD ERROR", children_error, d_key)
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        {childrens.map((items, childIndex) => {
          return (
            <Row
              type={display_type === "horizontal" ? "flex" : "none"}
              justify="space-around"
              style={{ flexWrap: "nowrap", alignItems: "flex-end" }}
            >
              {items.map((item, index) => {
                let subchildren_error = {};
                let children_error_string = null;
                if (
                  this.props.submitted &&
                  children_error &&
                  children_error[childIndex] &&
                  item.children &&
                  typeof children_error[childIndex] === "object" &&
                  !Array.isArray(children_error[childIndex])
                ) {
                  subchildren_error = children_error[childIndex];
                } else if (
                  this.props.submitted &&
                  children_error &&
                  children_error[childIndex] &&
                  item.children
                ) {
                  children_error_string = children_error[childIndex];
                }
                return (
                  <div key={item.index} style={{ padding: 5 }}>
                    <Row
                      type="flex"
                      style={{
                        alignItems: "center",
                      }}
                    >
                      <label>{item.name}</label> &nbsp;{" "}
                      {item.help_text && (
                        <Tooltip title={item.help_text}>
                          <HelpOutlineOutlined
                            style={{
                              height: 16,
                            }}
                            type="question-circle"
                          />
                        </Tooltip>
                      )}
                    </Row>
                    {item.children
                      ? this._getFieldsForChildren(
                          item,
                          index,
                          subchildren_error[item.index],
                          `${s_key}[${childIndex}][${index}].children`,
                          `${d_key}[${childIndex}].${item.index}`
                        )
                      : this._getFieldByType(
                          item,
                          `${d_key}[${childIndex}].${item.index}`
                        )}

                    {children_error[childIndex] &&
                      children_error[childIndex][item.index] &&
                      !item.children &&
                      (Array.isArray(children_error[childIndex][item.index]) ? (
                        children_error[childIndex][item.index].map(
                          (error, error_index) => (
                            <div
                              style={{ minHeight: 22, maginTop: 1 }}
                              key={error_index}
                            >
                              <span style={{ color: "red" }}> {error} </span>
                            </div>
                          )
                        )
                      ) : (
                        <div style={{ minHeight: 22, maginTop: 1 }}>
                          <span style={{ color: "red" }}>
                            {" "}
                            {children_error[childIndex][item.index]}{" "}
                          </span>
                        </div>
                      ))}
                  </div>
                );
              })}
              <center>
                <Button
                  disabled={childrens.length <= min_children}
                  onClick={() =>
                    this.removeChildren(`${s_key}`, `${d_key}`, childIndex)
                  }
                  type="link"
                  style={{
                    color: "red",
                    display: "flex",
                    alignItems: "center",
                    opacity:
                      min_children == 0
                        ? 1
                        : childrens.length <= min_children
                        ? 0
                        : 1,
                  }}
                >
                  <DeleteOutlineOutlined type="delete" />
                  {display_type === "vertical" ? "Delete" : ""}
                </Button>
              </center>
            </Row>
          );
        })}
        <br></br>
        <center>
          {multiple && childrens.length < max_children && (
            <Button onClick={() => this.addChildren(s_key)}>
              {data.add_more || "Add More"}
            </Button>
          )}
        </center>
      </div>
    );
  }

  _getAdditionalForm(item, parentIndex) {
    let affecting_value = null;
    let current_value = {};
    let append_key = item.append_key;
    let _additional_forms = this.state.additional_forms;

    affecting_value = objectbyString(this.state.data, item.index);
    current_value = objectbyString(this.state.data, append_key);

    let schema_options = item.optional_schema || {};
    let new_schema = schema_to_field(schema_options[affecting_value] || []);

    if (!lodash.isEqual(_additional_forms[item.index], new_schema)) {
      console.log("object not equal");
      this.setState({
        additional_forms: {
          ..._additional_forms,
          [item.index]: new_schema,
        },
      });
    }
    // if(_additional_forms[item.index]!=new_schema){
    //   console.log("additional repeated")
    //   // this.setState({
    //   //   additional_forms:{
    //   //     ..._additional_forms,
    //   //     [item.index]:new_schema
    //   //   }
    //   // })
    // }

    console.log("form  created created");
    // console.log("getting additional form",append_key,new_schema,schema_options,affecting_value)
    return (
      <div>
        <Form
          should_change_schema={false}
          forCreate={true}
          initialData={append_key ? current_value : this.state.data}
          parentData={{
            ...this.props.parentData,
            ...this.props.initialData,
            ...this.state.data,
          }}
          isChild={true}
          submitted={this.props.submitted}
          form_style={{ display: "flex", flex: 1, flexDirection: "column" }}
          onChange={(received_value) => {
            // console.log("received valus from nested",received_value,append_key);
            if (!append_key) {
              this.setState({ data: received_value }, () =>
                this.props.onChange(this.state.data)
              );
            } else {
              this._change(append_key, received_value, append_key);
            }
          }}
          fields={this.state.additional_forms[item.index] || new_schema}
          errorMessage={{}}
          validationErrors={
            this.props.validationErrors
              ? this.props.validationErrors[item.index]
              : {}
          }
        />
      </div>
    );
  }

  _getInputFields() {
    const { toggle_json_config } = this.state;

    return this.state.schema
      .filter(
        (item) =>
          (this.props.forCreate === true && item.show_create !== false) ||
          (this.props.forCreate === false && item.show_update !== false)
      )
      .map((item, parentIndex) => {
        // console.log("item is",item)
        let children_error = {};
        let children_error_string = null;
        if (
          this.props.submitted &&
          this.props.validationErrors &&
          this.props.validationErrors[item.index] &&
          item.children &&
          typeof this.props.validationErrors[item.index] === "object" &&
          !Array.isArray(this.props.validationErrors[item.index])
        ) {
          children_error = this.props.validationErrors[item.index];
        } else if (
          this.props.submitted &&
          this.props.validationErrors &&
          this.props.validationErrors[item.index] &&
          item.children
        ) {
          children_error_string = this.props.validationErrors[item.index];
        }

        let form_value = null;
        form_value = objectbyString(this.state.data, item.index);
        return (
          <div
            key={item.index}
            style={{
              padding: 5,
              display: "flex",
              flexDirection: this.props.isHorizontal ? "row" : "column",
              width: this.props.isHorizontal ? "50%" : null,
              alignItems: this.props.isHorizontal ? "center" : null,
              ...item.style,
            }}
          >
            <Row
              type="flex"
              justify="space-between"
              style={{
                flexWrap: "nowrap",
                alignItems: "center",
              }}
            >
              <Row
                type="flex"
                style={{
                  alignItems: "center",
                  flexWrap: "nowrap",
                }}
              >
                <label>
                  {item.name}{" "}
                  {item.required && <span style={{ color: "red" }}>*</span>}
                </label>{" "}
                &nbsp;&nbsp;{" "}
                {item.help_text && (
                  <Tooltip title={item.help_text}>
                    <HelpOutlineOutlined
                      style={{
                        height: 16,
                      }}
                      type="question-circle"
                    />
                  </Tooltip>
                )}
                &nbsp;&nbsp;&nbsp;
              </Row>
              {item.toggle_main_json == true && (
                <div className="hoverable-switch hand-cursor">
                  <CustomSwitch
                    className="hoverable-switch-child"
                    title="Switch between JSON Editor and UI Editor"
                    value={toggle_json_config[item.index] || "UI"}
                    trueItem="UI"
                    falseItem="JSON EDITOR"
                    onChange={(value) => {
                      this.setState({
                        toggle_json_config: {
                          ...toggle_json_config,
                          [item.index]: value,
                        },
                      });
                    }}
                  />
                </div>
              )}
            </Row>
            {toggle_json_config[item.index] == "JSON EDITOR" ? (
              <div className="json-editor-wrapper large">
                <Editor
                  mode={Editor.modes.code}
                  value={form_value}
                  onChange={(value) => {
                    console.log("change value is", value);

                    this._change(item.index, value, item.index);
                  }}
                  className="small-json-editor"
                  search={false}
                  navigationBar={false}
                  statusBar={false}
                  ace={ace}
                  // theme="ace/theme/github"
                />
              </div>
            ) : item.children ? (
              this._getFieldsForChildren(
                item,
                parentIndex,
                children_error,
                `[${parentIndex}].children`,
                item.index
              )
            ) : item.multiple ? (
              this._getMultipleFieldByType(item, `[${parentIndex}]`, item.index)
            ) : (
              this._getFieldByType(item, item.index)
            )}
            {this.props.submitted &&
              this.props.validationErrors &&
              this.props.validationErrors[item.index] &&
              !item.children &&
              !item.multiple &&
              (Array.isArray(this.props.validationErrors[item.index]) ? (
                this.props.validationErrors[item.index].map(
                  (error, error_index) => (
                    <div
                      style={{ minHeight: 22, maginTop: 1 }}
                      key={error_index}
                    >
                      <span style={{ color: "red" }}> {error} </span>
                    </div>
                  )
                )
              ) : (
                <div style={{ minHeight: 22, maginTop: 1 }}>
                  <span style={{ color: "red" }}>
                    {" "}
                    {this.props.validationErrors[item.index]}{" "}
                  </span>
                </div>
              ))}
            {children_error_string &&
              children_error_string.map((error, error_index) => (
                <div style={{ minHeight: 22, maginTop: 1 }} key={error_index}>
                  <span style={{ color: "red" }}> {error} </span>
                </div>
              ))}
            <div>
              {item.additional && this._getAdditionalForm(item, parentIndex)}
            </div>
          </div>
        );
      });
  }

  _change(field, value, d_key = "null") {
    // value = value ? value : '';

    let data = this.state.data;

    console.log("DATA changing", d_key, value);

    let a =
      objectAssignerByString(data, d_key, value, this.props.stringyfy) || {};
    // if(parentKey){
    //   if(!data[parentKey]){
    //     data[parentKey]=[]
    //   }
    //   if(!data[parentKey][childIndex]){
    //     data[parentKey][childIndex]={}
    //   }
    //   data[parentKey][childIndex][field]=value
    // }else
    // {
    // data={...data,[field]:value}
    // }
    this.setState({ data: a }, () => this.props.onChange(this.state.data));
  }

  _addBase64Buffer(field, file) {
    let reader = new FileReader();
    reader.addEventListener(
      "loadend",
      () => {
        this.data_buffers[field] = reader.result;

        let times_loaded = 1;
        if (
          this.state.__base64_buffer__ &&
          this.state.__base64_buffer__[field]
        ) {
          times_loaded = this.state.__base64_buffer__[field] + 1;
        }
        this.setState(
          {
            __base64_buffer__: {
              ...this.state.__base64_buffer__,
              [field]: times_loaded,
            },
          },
          () => null
        );
      },
      false
    );
    reader.readAsDataURL(file);
  }

  render() {
    return (
      <div style={this.props.form_style}>
        <div style={{ minHeight: 2, maginTop: 1, textAlign: "center" }}>
          {this.props.submitted &&
            this.props.errorMessage &&
            Object.keys(this.props.errorMessage).length > 0 && (
              <h5 style={{ color: "red" }}>
                {JSON.stringify(this.props.errorMessage, null, 4)}
              </h5>
            )}
        </div>
        {/* {JSON.stringify(this.props.fields)} */}

        {/* <Row type='flex'> */}
        <div
          style={{
            display: this.props.isHorizontal ? "flex" : null,
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: this.props.isHorizontal ? "center" : null,
          }}
        >
          {this._getInputFields()}
        </div>
        {/* </Row> */}
      </div>
    );
  }

  componentDidMount() {
    this.reconcileSchemaBasedOnForm(this.state.schema, this.state.data);
  }

  componentWillReceiveProps(nextProps) {
    if (!lodash.isEqual(this.props.initialData, nextProps.initialData)) {
      console.log(
        "NEW INITIAL DATA",
        nextProps.initialData,
        this.props.initialData
      );
      if (
        nextProps.initialData &&
        Object.keys(nextProps.initialData).length >= 0
      ) {
        this.setState({ data: nextProps.initialData });
      }
    }
    if (!lodash.isEqual(this.props.fields, nextProps.fields)) {
      console.log("schema changed");
      // console.log("shodn't change schema for",this.props.should_change_schema,nextProps.fields)
      if (Array.isArray(nextProps.fields)) {
        this.setState({
          schema: nextProps.fields,
        });
      }
    }
  }
}

Form.propTypes = {
  initialData: PropTypes.object,
  schema: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};
export default Form;

// {
//     name: "Services",
//     index: 'services',
//     multiple: true,
//     min: 1,
//     max: 5,
//     add_more: "Add More Services",
//     positioning: 'vertical',
//     children: [
//         [
//             {
//                 name: 'Service Name',
//                 index: 'service_name',
//                 type: 'select',
//                 options: []
//             }, {
//                 name: 'Extractors',
//                 index: 'extractors',
//                 multiple: true,
//                 min: 1,
//                 max: 5,
//                 add_more: "Add More Extractor",
//                 positioning: 'horizontal',
//                 children: [
//                     [
//                         {
//                             name: 'Field Name',
//                             index: 'field_name',
//                             type: 'text'
//                         }, {
//                             name: 'DB Col Name',
//                             index: 'db_column_name',
//                             type: 'text'
//                         }, {
//                             name: 'Reg Ex',
//                             index: 'regex',
//                             type: 'text'
//                         }
//                     ]
//                 ]
//             }
//         ]
//     ]
// }
